export default __webpack_public_path__ + "static/char-s-61-en-966e2b35efa1bb163786fe86d5a1615a.png";